import styled from 'styled-components'

export interface Props {
  className?: string
  src: string
  width?: string
  height?: string
  borderRadius?: string
  alt?: string
  isRatioMaintained?: boolean
  onClick?: (event: React.MouseEvent) => void
}

const CenteredImage: React.FC<Props> = ({
  className,
  src,
  width = '100%',
  height = '100%',
  isRatioMaintained = false,
  alt,
  onClick,
}): JSX.Element => {
  return (
    <StyledContainer className={className} $width={width} $height={height} onClick={onClick}>
      <StyledImage src={src} $isRatioMaintained={isRatioMaintained} alt={alt} />
    </StyledContainer>
  )
}

interface StyledContainerProps {
  $width?: string
  $height?: string
}
const StyledContainer = styled.div<StyledContainerProps>`
  position: relative;
  display: inline-block;
  width: ${({ $width }) => $width || 'auto'};
  &:after {
    content: '';
    display: block;
    padding-top: 100%; /* The padding depends on the width, not on the height, so with a padding-bottom of 100% you will get a square */
  }
`
interface StyledImageProps {
  $isRatioMaintained?: boolean
}
const StyledImage = styled.img<StyledImageProps>`
  position: absolute; /* Take your picture out of the flow */
  top: 0;
  bottom: 0;
  left: 0;
  right: 0; /* Make the picture taking the size of it's parent */
  width: 100%; /* This if for the object-fit */
  height: 100%; /* This if for the object-fit */
  object-fit: cover; /* Equivalent of the background-size: cover; of a background-image */
  object-position: center;
  border-radius: inherit;

  ${({ $isRatioMaintained }) => $isRatioMaintained && 'object-fit: contain'}
`

export default CenteredImage
